<template>
  <section
    v-if="$t('HOME.OTHERS.LINKS.googlePlay') && $t('HOME.OTHERS.LINKS.appleStore')"
    class="banner"
  >
    <h3 class="banner__title">
      Experimente o app de "{{ $t('APP.name') }}"!
    </h3>
    <div class="banner__links">
      <a
        :href="$t('HOME.OTHERS.LINKS.appleStore')"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="@/assets/img/app-store-badge.svg"
          alt="Baixar na App Store"
        >
      </a>
      <a
        :href="$t('HOME.OTHERS.LINKS.googlePlay')"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="@/assets/img/google-play-badge.svg"
          alt="Disponível no Google Play"
        >
      </a>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppBannerSecondary',
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  background-color: $step-select;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  row-gap: $spacing-05;
  padding: $spacing-07 max(4%, calc(50% - $max-width-mobile/2));

  @include screen(tablet-big-up) {
    flex-direction: row;
    padding: $spacing-07 max(8%, calc(50% - $max-width-desktop/2));
  }

  &__title {
    text-align: center;

    @include title-xs($weight: 2);

    @include screen (tablet-big-up) {
      @include title-s;
    }
  }

  &__links {
    display: flex;
    align-items: center;
    column-gap: $spacing-05;

    img {
      height: 2.65rem;
    }
  }

  @media print {
    display: none;
  }
}
</style>
